import { Alert } from 'src/app/models/Alert';

/**
 * Resolve an in-app router path from alert.deepLink (absolute or relative)
 * or fall back to /cases/{relatedEntityId} for ticket alerts.
 */
export function alertDeepLinkPath(alert: Alert): string | null {
  const fromDeepLink = toAppPath(alert.deepLink);
  if (fromDeepLink) {
    return fromDeepLink;
  }

  const ticketId = (alert.relatedEntityId || '').trim();
  const relatedType = (alert.relatedEntityType || '').trim().toLowerCase();
  if (ticketId && (relatedType === 'ticket' || isCaseExternalMessage(alert))) {
    return `/cases/${ticketId}`;
  }

  return null;
}

export function isCaseExternalMessage(alert: Alert): boolean {
  const raw = alert.eventType ?? alert.category;
  if (raw === null || raw === undefined || raw === '') {
    return false;
  }
  const key = String(raw).trim();
  return key === 'CaseExternalMessage' || key === '3';
}

function toAppPath(deepLink?: string | null): string | null {
  if (!deepLink || !deepLink.trim()) {
    return null;
  }

  const value = deepLink.trim();
  if (value.startsWith('/')) {
    return value;
  }

  try {
    const url = new URL(value);
    return `${url.pathname}${url.search}${url.hash}` || null;
  } catch {
    return null;
  }
}
